import { factory } from '@/interfaces/factory'
import { BaseRequest } from '@/network/requests/BaseRequest'

const _request = BaseRequest.build<factory>('factory')

/**
 * 初始化工厂。
 * @param obj 工厂对象。
 */
var initFactory = (obj: factory) => {
	return _request.upload(obj)
}

/**
 * 查询工厂信息。
 * @param id 工厂Id。
 */
var getFactoryInfo = (id: string) => {
	return _request.getDocumentById(id)
}

/**
 *
 */
var getAll = () => {
	return _request.queryAll()
}

const getFactory = async () => {
	const all = await getAll();
	if (all.length > 0) {
		return all[0];
	}
	return null;
}

export default {
	initFactory,
	getFactoryInfo,
	getAll,
	getFactory,
}
